import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
import defaultGetWasChanged from '../defaultGetWasChanged';
import { constructFieldKey } from './constructFieldKey';
function getFieldStates(fields, createFieldsForEachId, getFieldState) {
  var newFieldStates = {};
  Object.entries(fields).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      field = _ref2[1];
    if (createFieldsForEachId) {
      createFieldsForEachId.forEach(function (id) {
        var dynamicKey = constructFieldKey(key, id);
        var defaultValue = field.getDefaultValue(id);
        var fieldState = getFieldState({
          field: field,
          key: dynamicKey,
          defaultValue: defaultValue
        });
        newFieldStates[dynamicKey] = fieldState;
      });
    } else {
      var defaultValue = field.getDefaultValue();
      var fieldState = getFieldState({
        field: field,
        key: key,
        defaultValue: defaultValue
      });
      newFieldStates[key] = fieldState;
    }
  });
  return newFieldStates;
}

/**
 * Resets the state of all fields back to their default value
 */

export function getDefaultFieldStates(fields, createFieldsForEachId) {
  return getFieldStates(fields, createFieldsForEachId, function (_ref3) {
    var defaultValue = _ref3.defaultValue;
    return {
      value: defaultValue,
      defaultValue: defaultValue,
      changedValue: undefined,
      wasChanged: false
    };
  });
}

/**
 * Resets the state of all unchanged fields back to their default value.
 */

export function getUnchangedDefaultFieldStates(fields, createFieldsForEachId, fieldStates) {
  return getFieldStates(fields, createFieldsForEachId, function (_ref4) {
    var _currentFieldState$ch;
    var field = _ref4.field,
      key = _ref4.key,
      defaultValue = _ref4.defaultValue;
    var _field$getWasChanged = field.getWasChanged,
      getWasChanged = _field$getWasChanged === void 0 ? defaultGetWasChanged : _field$getWasChanged;
    var currentFieldState = fieldStates[key];
    var currentValue = (_currentFieldState$ch = currentFieldState === null || currentFieldState === void 0 ? void 0 : currentFieldState.changedValue) !== null && _currentFieldState$ch !== void 0 ? _currentFieldState$ch : defaultValue;
    var wasChanged = getWasChanged(defaultValue, currentValue);
    return {
      value: wasChanged ? currentValue : defaultValue,
      defaultValue: defaultValue,
      changedValue: wasChanged ? currentValue : undefined,
      wasChanged: wasChanged
    };
  });
}